import { Reducer } from 'redux';
import {
  SITE_WRAPPER_VISIBILITY,
} from '../actions/siteWrapperAction';
import { ISiteWrapper } from '../types';

const initialState: ISiteWrapper = {
  show: true,
};

const siteWrapperReducer: Reducer<ISiteWrapper> = (state: ISiteWrapper = initialState, action) => {
  if (action.type === SITE_WRAPPER_VISIBILITY) {
    return {
      ...state,
      show: action.payload,
    };
  }
  return state;
};

export default siteWrapperReducer;
